export default __webpack_public_path__ + "static/media/pre-op-3.04c25ff5.jpg";